import React, { useState } from 'react';
import { Upload, Icon, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { notificationTypes } from '../../../constants';
import { showNotification } from '..';
import i18n from '../../../i18n';

import styles from './Uploader.module.scss';

const fileEntrySize = entry =>
  (entry?.size ?? entry?.file?.size ?? entry?.originFileObj?.size ?? 0);

export const Uploader = ({
  id,
  canPreview = false,
  accept,
  multiple = false,
  listType = 'text',
  name = 'files',
  withAsterisks,
  icon = 'file',
  isCSV = false,
  onload,
  fileList,
  onRemove,
  limit,
  disabled,
  sizeLimit = 5
}) => {
  const [ t ] = useTranslation();
  const [ img, setImage ] = useState();

  const onChangeHandler = async file => {
    const reader = new FileReader();
    reader.onload = e => {
      // onload({ url: e.target.result, file, uid: fileList.length + 1 });
      onload(file, e.target.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div data-testid="test-id">
      <Modal
        width={ 800 }
        visible={ !!img && canPreview }
        footer={ null }
        onCancel={ () => { setImage(); } }
      >
        <img style={{ maxWidth: '100%' }} src={ img } alt="" />
      </Modal>
      <Upload.Dragger
        onPreview={ file => { canPreview && setImage(file.url); } }
        listType={ listType }
        name={ name }
        id={ id }
        multiple={ multiple }
        accept={ isCSV ? '.csv' : accept }
        fileList={ fileList ?? [] }
        onRemove={ onRemove }
        // Prevent upload
        customRequest={ () => {} }
        disabled={ disabled }
        action={ async file => {
          const fileSize = (fileList ?? []).reduce((p, c) => p + fileEntrySize(c), 0) + file.size;

          if ((limit && fileList.length === limit) || fileSize > sizeLimit * 1024 * 1024) {
              showNotification({
                  type: notificationTypes.ERROR,
                  title: t('ERR.limitExceeded')
              });

              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject('limit exceeded');
          }
          const ext = accept.replaceAll(' ', '').split(',');
          const supported = ext.reduce(
              (prev, current) => prev || file.name.toLowerCase().endsWith(current),
              false
          );
          if (!supported) {
            showNotification({ type: notificationTypes.ERROR, title: t('ERR.20007') });

            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject('not supported file');

          }

          if (isCSV) {
            const reader = new FileReader();
            reader.onload = e => {
              onload(file, e.target.result);
            };
            reader.readAsText(file);
          } else {
            await onChangeHandler(file);
          }

          return null;
        } }
      >
        <p className={ styles.icon }>
          <Icon type={ icon } />
        </p>
        <label className={ styles.label }>
          {`${t('btns.dragUpload')} (${t('fields.maxSize')}). ${t('AllowedFiles')} ${accept}`}
          {withAsterisks && <span className={ styles.asterisks }>{' *'}</span>}
        </label>
      </Upload.Dragger>
    </div>
  );
};
